import { ReadApiError } from '../../../../types';

function readApiErrorTypeDef(error: unknown): error is ReadApiError {
  return (error as ReadApiError)?.response?.data?.error ? true : false;
}

export default readApiErrorTypeDef;
